/**
 * Filtering mode enum defines the filering modes of DataModel.
 *
 * @readonly
 * @enum {string}
 */
const FilteringMode = {
    NORMAL: 'normal',
    INVERSE: 'inverse',
    ALL: 'all'
};

export default FilteringMode;
